import { SeaoilLogo, YellowGasTanker } from "images";
import styles from "./forgot-password.module.scss";
import locale from "localization";
import classNames from "classnames";
import {
  Button,
  Field,
  Footer,
  Highlight,
  Image,
  PasswordField,
  Text,
  TextField,
  Title,
} from "components/commons";
import { useForm, useRouter } from "hooks";
import { useMemo } from "react";
import { Path } from "enums";
import initialState from "./forgot-password.state";

const ForgotPasswordModule = () => {
  const router = useRouter();
  const isExpired = router?.query?.expired;

  const { fields, isFormSubmittable, modifyField } = useForm({
    initialState: useMemo(() => {
      const isExpired = router?.query?.expired;
      return initialState(isExpired);
    }, [router?.query?.expired]),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormSubmittable) return;

    if (isExpired && isExpired === "false") {
      return alert(fields.password.value);
    }

    alert(fields.email.value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.container}>
        <div className={classNames(styles.header)}>
          <Image src={SeaoilLogo} className={styles.SeaoilLogoImage} />
        </div>

        <div className={styles.content}>
          <div className={styles.contentContainer}>
            <div className={styles.image}>
              <Image src={YellowGasTanker} className={styles.contentImage} />
            </div>

            <div className={styles.login}>
              <Title className={styles.title}>{locale.seaoilPortal}</Title>
              <Text className={styles.passwordResetTxt}>{locale.passwordReset}</Text>
              {isExpired && isExpired === "true" && (
                <Highlight error>
                  <Text>{locale.linkExpiredMessage}</Text>
                </Highlight>
              )}

              {(!isExpired || (isExpired && isExpired === "true")) && (
                <Field {...fields.email}>
                  <TextField
                    {...fields.email}
                    onChange={(name, props) => {
                      if (isExpired && isExpired === "true") {
                        router.replace(Path.AuthForgotPassword);
                      }
                      modifyField(name, props);
                    }}
                  />
                </Field>
              )}
              {isExpired && isExpired === "false" && (
                <>
                  <Field
                    {...fields.password}
                    message={fields?.password?.message || locale.use8CharWithMix}
                  >
                    <PasswordField {...fields.password} onChange={modifyField} />
                  </Field>
                  <Field {...fields.confirmPassword}>
                    <PasswordField {...fields.confirmPassword} onChange={modifyField} />
                  </Field>
                </>
              )}
              <div className={styles.actionsBtn}>
                <Button
                  onClick={() => {
                    router.replace(Path.Auth);
                  }}
                >
                  {locale.cancel}
                </Button>
                <Button
                  disabled={!isFormSubmittable}
                  primary
                  className={styles.loginButton}
                  type="submit"
                >
                  {locale.continue}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </form>
  );
};

export default ForgotPasswordModule;
